import { actions, internalSubjects, allSubjects } from './permissions-constants';

export const ACCOUNT_TYPE = Object.freeze(['OPERATOR', 'NON-OPERATOR', 'SERVICE', 'CONSULTANT', 'UNIVERSITY']);
export const INDUSTRY_TYPE = Object.freeze([
  'OIL & GAS',
  'GEOTHERMAL',
  'CCUS',
  'ACADEMIC',
  'OTHER',
]);
export const CONTRACT_TYPE_LIST = Object.freeze({
  'FREE TRIAL': 'FREE TRIAL',
  CUSTOMER: 'CUSTOMER',
  PILOT: 'PILOT',
  INTERNAL: 'INTERNAL',
});

export const CONTRACT_TYPE = Object.freeze(Object.values(CONTRACT_TYPE_LIST));

export const IDENTITY_SERVER_COMMUNICATION = Object.freeze({
  [Symbol.for('SUCCESS')]: 200,
  [Symbol.for('NOT_FOUND')]: 404
});

export const SubjectsMap = Object.freeze({...internalSubjects, ...allSubjects});

export const ActionMap  = Object.freeze(actions);
export const subjects = Object.values(SubjectsMap);

export const CUSTOMER_ADMIN = 'customer-admin';
export const INTRANET = 'Intranet';
export const WELLDESIGN = 'welldesign';
export const ACCOUNT_OWNER = 'Account Owner';
export const ACCOUNT_REPRESENTATIVE = 'Customer Success Representative';
export const ADMIN = 'ADMIN';
export const VIEWER = 'VIEWER';
export const MANAGER = 'MANAGER';
export const OliasoftMainCompanyName = 'Oliasoft AS';

export const EMAIL_TYPES = Object.freeze({
  WELCOME: 'Welcome',
  RESET_PASSWORD: 'ResetPassword',
  PASSWORD_CHANGED: 'PasswordChanged',
  SCIM: 'WelcomeScim',
  LICENSE_EXPIRATION_7_DAYS: 'LicenceExpiration7days',
  LICENSE_EXPIRATION_1_DAY: 'LicenceExpiration1day',
});

export const DELETE_TYPES = Object.freeze({
  SOFT: 'soft',
  HARD: 'hard',
});

export const REGEXP_VALID_DATE = /20\d{2}-\d{2}-\d{2}/;

export enum AllSettledStatuses {
  FULFILLED = 'fulfilled',
  REJECTED = 'rejected'
}

export const DEFAULT_RESULTS_PER_PAGE = 100;

export const USER_TYPE_LIST = Object.freeze([
  'drillingEngineer',
  'completionEngineer',
  'sme',
  'manager',
  'student',
  'professor',
  'wellPlannner',
  'other'
]);
